var generateStyle = function generateStyle(componentTheme) {
  return {
    root: {
      fontFamily: componentTheme.fontFamily,
      color: componentTheme.fontColor
    }
  };
};
export default generateStyle;